<div class="tw-flex tw-justify-center tw-pb-4">
  <ate-logo size="large"></ate-logo>
</div>
<p class="tw-text-center tw-text-slate-700">We are sorry, there was a problem with the site. Please refresh this page.</p>
